import { lazy, Suspense } from "react";
import { Box } from "@mui/material";
import CustomHelmet from "../common/CustomHelmet";
import Welcome from "./Welcome";
import ServicesChips from "./ServiceChips";
import InsuranceStrip from "./InsuranceStrip";
// These sections render below the fold but must mount with the page.
// Lazy-loading them inserted content after first paint and pushed
// everything down, which was the homepage's entire layout shift score.
import ProfileSection from "./ProfileSection";
import ContactSection from "./ContactSection";
import FAQPage from "./FAQ/FAQ";
import GoogleMapsSection from "../common/Map";

// BlogStrip stays lazy on purpose: it pulls in the article bundle, which
// would otherwise land in the homepage's critical path. The Suspense
// fallback reserves its height so the map below doesn't shift on mount.
const BlogStrip = lazy(() => import("./BlogStrip"));

function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Dr. Anne Rothenberg",
    url: "https://drannerothenberg.com/",
    telephone: "+1-407-797-5469",
    sameAs: ["https://www.facebook.com/profile.php?id=100064161485273"],
  };

  return (
    <>
      <CustomHelmet
        title="Dr. Anne Rothenberg - Marriage and Couples Sexologist in Maitland, FL"
        description="Dr. Anne Rothenberg, Ph.D., LMHC 14391 offers compassionate, personalized counseling to enhance relationships and well-being."
        keywords="Orlando marriage counseling, LGBTQ+ therapy Orlando, Dr. Anne Rothenberg, porn addiction therapy, narcissism counseling, sexologist in Orlando, Cigna health insurance counseling"
        ogTitle="Dr. Anne Rothenberg - Board Certified Clinical Sexologist"
        ogDescription="Board Certified Clinical Sexologist and Licensed Mental Health Counselor specializing in couples therapy and sexual health in Maitland, FL."
        ogUrl="https://drannerothenberg.com/"
        canonicalUrl="https://drannerothenberg.com/"
        jsonLd={jsonLd}
      />
      <Welcome />
      <ServicesChips />
      <InsuranceStrip />
      <ProfileSection />
      <ContactSection />
      <FAQPage />
      <Suspense fallback={<Box sx={{ minHeight: { xs: 460, md: 320 } }} />}>
        <BlogStrip />
      </Suspense>
      <GoogleMapsSection />
    </>
  );
}

export default Home;
